var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6B511A",
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "applications-solid-alerted") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-1--alerted"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-2--alerted"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-3--alerted"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-4--alerted"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-5--alerted"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-6--alerted"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 6,
    height: 6,
    className: "clr-i-solid--alerted clr-i-solid-path-7--alerted"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,10h4L19,9.89,21,6.5V4H15Z",
    className: "clr-i-solid--alerted clr-i-solid-path-8--alerted"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.85,1.14,21.13,11A1.28,1.28,0,0,0,22.23,13H33.68A1.28,1.28,0,0,0,34.78,11L29.06,1.14A1.28,1.28,0,0,0,26.85,1.14Z",
    className: "clr-i-solid--alerted clr-i-solid-path-9--alerted clr-i-alert"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.25522d8a3569d39023bd68d14b96fb55.svg";
export { ForwardRef as ReactComponent };